module.exports = __webpack_public_path__ + "img/logo.7870d03f.svg";